module.exports = __webpack_public_path__ + "img/MagneticPersonality.c83ead00.png";